







































































import { Component, Watch } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import CreateJourneyTemplateRequest from '@/models/JourneyTemplates/CreateJourneyTemplateRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import JourneyTemplateDto from '@/models/JourneyTemplates/JourneyTemplateDto';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JourneyTemplateCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new JourneyTemplateDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new JourneyTemplateDto();
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  get travelTimes() {
    return ListUtils.travelTimes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateJourneyTemplateRequest()
    request.name = this.entity.name;
    request.distanceOneWay = Number(this.entity.distanceOneWay)
    request.travelTimeOneWay = this.entity.travelTimeOneWay
    await LocationDetailsModule.createJourneyTemplate(request)
    this.dialog = false;
  }
}
